/**
 * Fallback player for `type: "WEB"` stations — a sandboxed iframe.
 *
 * We deliberately do NOT grant `allow-top-navigation` or
 * `allow-modals` so a compromised upstream page can't hijack the tab.
 * `allow-same-origin` is required by many station players to store
 * their session cookie; drop it for stricter isolation if we ever move
 * to a trusted-source-only model.
 */
export function WebPlayer({ src }: { src: string }) {
  return (
    <iframe
      src={src}
      title="stream"
      className="w-full h-full bg-black border-0"
      allow="autoplay; encrypted-media; picture-in-picture"
      sandbox="allow-scripts allow-same-origin allow-presentation allow-forms"
    />
  );
}
